<template>
  <v-row>
    <v-col cols="12">
      <v-icon color="primary">ph-scroll</v-icon>
      <span class="pl-1">Consultas</span>
    </v-col>
    <v-col cols="12">
      <v-row class="contadores-base-consulta justify-space-between">
        <v-col class="contador-base-consulta rounded-lg text-body-2" cols="*"
          >Realizadas em {{ dtAtual }} <span class="text-subtitle-1 font-weight-bold">{{ contador.mensal ?? 0 }}</span>
        </v-col>
        <v-col class="contador-base-consulta rounded-lg text-body-2" cols="*"
          >Últimos 12 meses <span class="text-subtitle-1 font-weight-bold">{{ contador.anual ?? 0 }}</span>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon @click="openDetalhes" color="primary" v-on="on">ph-magnifying-glass</v-icon>
            </template>
            <span>Detalhes</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>
    <LogDetalhes ref="detalhes" />
  </v-row>
</template>

<script>
import { defineAsyncComponent } from 'vue'
export default {
  components: {
    LogDetalhes: defineAsyncComponent(() =>
      import(`../views/${window.$bancodofuturo}/base-consultas/LogDetalhes.vue`)
    )
  },
  data () {
    return {
      contador: {},
      dados: {},
      bureau: '',
    }
  },
  computed: {
    dtAtual () {
      return this.$api.UI.Format.Date(new Date(), 'MM/yyyy');
    },
  },
  methods: {
    buscaContador (bureau) {
      const th = this;
      th.$set(th, 'bureau', bureau)
      var dto = {
        parms: [
          { name: 'PeriodoFim', value: th.$api.UI.Format.Date(new Date(), 'yyyy-MM') },
          { name: 'PeriodoInicio', value: th.$api.UI.Format.Date(this.$api.UI.Date.AddMonth(new Date(), -12), 'yyyy-MM') },
          { name: 'DocumentoParceiro', value: th.$api.UI.Format.SomenteNumeros(th.$empresa.documentoFederal) },
        ]
      }
      switch (bureau) {
        case 'SCR BACEN':
          dto.parms.push({ name: 'Bureau', value: 12 });
          break;
        case 'SERASA':
          dto.parms.push({ name: 'Bureau', value: 13 });
          break;
        case 'SPC BRASIL':
          dto.parms.push({ name: 'Bureau', value: 14 });
          break;
        case 'ALL CHECK':
          dto.parms.push({ name: 'Bureau', value: 1 });
          break;
        case 'ASSERTIVA':
          dto.parms.push({ name: 'Bureau', value: 2 });
          break;
        case 'DATA BUSCA':
          dto.parms.push({ name: 'Bureau', value: 5 });
          break;
        case 'EMAILAGE':
          dto.parms.push({ name: 'Bureau', value: 5 });
          break;
      }
      th.$api.Multiplo.Post('ConsultaLogPorPeriodo', dto).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th, 'dados', response.Faturado)
          var periodoAtual = response.Faturado.find(p => p.Periodo === th.$api.UI.Format.Date(new Date(), 'yyyy-MM'))
          th.contador = {
            mensal: periodoAtual ? periodoAtual.QuantidadeTotalPeriodo : 0,
            anual: response.QuantidadeTotal
          }
        }
      });
    },
    openDetalhes () {
      this.$refs.detalhes.openModal(this.dados, this.bureau)
    }
  }
}
</script>
<style scoped>
.contadores-base-consulta {
  gap: .5rem;
}
.contador-base-consulta {
  border: 2px solid #1f337d;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
